import { useEffect, useRef, useState } from 'react';

/**
 * Returns [ref, inView] — when the element first enters the viewport, `inView`
 * flips to true and stays there. Use it to trigger scroll-reveal animations.
 */
export default function useInView({ threshold = 0.12, rootMargin = '0px 0px -80px 0px' } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || inView) return;
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        obs.disconnect();
      }
    }, { threshold, rootMargin });
    obs.observe(el);
    return () => obs.disconnect();
  }, [inView, threshold, rootMargin]);

  return [ref, inView];
}
